import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';

export default {
  fields: [
    {
      type: 'number',
      name: 'amount',
      props: {
        required: true,
        label: (
          <p>
            <i className='asterisk icon inline' />
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.userDetail.modals.awardPoints.amount' />
            </IntlProvider>
          </p>
        )
      }
    },
    {
      type: 'text',
      name: 'reason',
      props: {
        required: true,
        label: (
          <p>
            <i className='asterisk icon inline' />
            <IntlProvider locale='en' messages={enUSmessage}>
              <FormattedMessage id='userManagement.userDetail.modals.awardPoints.reason' />
            </IntlProvider>
          </p>
        )
      }
    }
  ]
};



// WEBPACK FOOTER //
// ./public/pages/UserManagement/UserDetailPage/modals/AwardPointsModal/awardPointsFormConfig.jsx